module.exports = __webpack_public_path__ + "img/087.c9e712dd.png";